const storageGet = (key) => {
  const item = localStorage.getItem(key);

  if (item && item !== 'undefined') {
    return JSON.parse(item);
  }
  return null;
};

const storageSet = (props) => {
  const { key, value } = props;
  const oldValue = localStorage.getItem(key);
  localStorage.setItem(key, JSON.stringify(value));
  if (key === 'basketItems') {
    const event = new StorageEvent('storage', {
      key: 'basketItems',
      newValue: JSON.stringify(value),
      oldValue,
    });
    window.dispatchEvent(event);
  }
};

export { storageSet, storageGet };
